import parseNumber from 'multi-number-parse'

export enum DocumentLabelType {
  Amount = 'Amount',
  Bic = 'Bic',
  CayaUser = 'CayaUser',
  Email = 'Email',
  Iban = 'Iban',
  PaymentReceiver = 'PaymentReceiver',
  Phone = 'Phone',
  PostForwarding = 'PostForwarding',
  Recipient = 'Recipient',
  RecipientPublicId = 'RecipientPublicId',
  Reference = 'Reference',
  Sender = 'Sender',
  StampDate = 'StampDate',
  Subject = 'Subject',
  TrackingId = 'TrackingId',
}

export const LabelColors = {
  [DocumentLabelType.Subject]: '#F78D8A',
  [DocumentLabelType.Sender]: '#A2FA7B',
  [DocumentLabelType.Iban]: '#8DB8FF',
  [DocumentLabelType.Bic]: '#FF7293',
  [DocumentLabelType.Amount]: '#FCEE7C',
  [DocumentLabelType.Reference]: '#2483C7',
  [DocumentLabelType.PaymentReceiver]: '#F39500',
  [DocumentLabelType.CayaUser]: '#33CCFF',
  [DocumentLabelType.Recipient]: '#0099FF',
  [DocumentLabelType.PostForwarding]: '#CCFFFF',
  [DocumentLabelType.Email]: '#ACEACE',
  [DocumentLabelType.Phone]: '#D7A036',
  [DocumentLabelType.RecipientPublicId]: '#0099FF',
  [DocumentLabelType.StampDate]: '#0099FF',
  [DocumentLabelType.TrackingId]: '#0099FF',
}

/**
 * Replaces all occurrences of carriage return character such as \r or \n in supplied content with a single space
 */
function formatSubject(text: string) {
  return text.replace(/[\r\n|\n]/g, ' ')
}

export function formatLabel(text: string) {
  return text
    .replace(/(\s+|[\r\n\t])/g, ' ')
    .replace(/[^a-zA-Z0-9_äöüÄÖÜß€,.\s]+/g, '')
    .trim()
}

function formatIban(text: string) {
  return text.replace(/[^A-Za-z0-9]/g, '')
}

export function formatAmount(text: string): number {
  const formattedAmount = text
    .replace(/[Oo]/g, '0')
    .replace(/[lI]/g, '1')
    .replace('.', ',')
    .replace(/.*?(?=\d)/, '')
    .replace(/[^0-9,]/g, '')

  return parseNumber(formattedAmount, ',')
}

function assertIsNumber<T>(value: T): asserts value is T & number {
  if (typeof value !== 'number') {
    throw new Error(`Expected number, got ${typeof value}`)
  }
}

/**
 * Formats (OCR) content extracted from a label
 */
export function formatLabelText(
  type: DocumentLabelType.Amount,
  text: string
): number
export function formatLabelText(type: DocumentLabelType, text: string): string
export function formatLabelText(
  type: DocumentLabelType,
  text: string
): number | string {
  const formattedText = formatLabel(text)
  switch (type) {
    case DocumentLabelType.Subject:
      return formatSubject(formattedText)
    case DocumentLabelType.Iban:
      return formatIban(formattedText)
    case DocumentLabelType.Amount: {
      const amount = formatAmount(formattedText)
      assertIsNumber(amount)
      return amount
    }
    default:
      return formattedText
  }
}
